import { maprange } from "../functions/maprange";

function drawSupport(canvas, nodes, scale, width, height, freedomDegrees) {
    const ctx = canvas.getContext('2d')
    for (let i = 0; i < nodes.length; i++){
        if(freedomDegrees[i] === "1"){
            const xrect = maprange(nodes[i][0], 0, scale, 0, width)
            const yrect = maprange(nodes[i][1], 0, (height/width)*scale, 0, height)
            ctx.beginPath();
            ctx.strokeStyle = 'blue'
            ctx.moveTo(xrect, (height - yrect))
            ctx.lineTo(xrect - 20, (height - yrect) + 20)
            ctx.lineTo(xrect + 20, (height - yrect) + 20)
            ctx.lineTo(xrect, (height - yrect))
            ctx.moveTo(xrect - 20, (height - yrect) + 25)
            ctx.lineTo(xrect + 20, (height - yrect) + 25)
            ctx.stroke()
        }
        if(freedomDegrees[i] === "2"){
            const xrect = maprange(nodes[i][0], 0, scale, 0, width)
            const yrect = maprange(nodes[i][1], 0, (height/width)*scale, 0, height)
            ctx.beginPath();
            ctx.strokeStyle = 'blue'
            ctx.moveTo(xrect, (height - yrect))
            ctx.lineTo(xrect - 20, (height - yrect) + 20)
            ctx.lineTo(xrect + 20, (height - yrect) + 20)
            ctx.lineTo(xrect, (height - yrect))
            ctx.stroke()
        }
        if(freedomDegrees[i] === "3"){
            const xrect = maprange(nodes[i][0], 0, scale, 0, width)
            const yrect = maprange(nodes[i][1], 0, (height/width)*scale, 0, height)
            ctx.beginPath();
            ctx.strokeStyle = 'blue'
            ctx.lineWidth = 2
            ctx.lineTo(xrect - 20, (height - yrect)+2.5)
            ctx.lineTo(xrect + 20, (height - yrect)+2.5)
            ctx.stroke()
        }
    }
}

export default drawSupport